import memoize from 'memoize-one';

export const CreditScoreType = Object.freeze({
  creditScoreA: '1',
  creditScoreB: '2',
  creditScoreC: '3',
  creditScoreD: '4',
  creditScoreE: '5',
  creditScoreF: '6',
  creditScoreG: '7',
  creditScoreH: '8',
});

export const CreditScoreChartGrade = Object.freeze({
  [CreditScoreType.creditScoreA]: 8,
  [CreditScoreType.creditScoreB]: 7,
  [CreditScoreType.creditScoreC]: 6,
  [CreditScoreType.creditScoreD]: 5,
  [CreditScoreType.creditScoreE]: 4,
  [CreditScoreType.creditScoreF]: 3,
  [CreditScoreType.creditScoreG]: 2,
  [CreditScoreType.creditScoreH]: 1,
});

export const CreditScoreStatusType = Object.freeze({
  normal: 'normal',
  warning: 'warning',
  risk: 'risk',
});

export const CreditScoreTypeLetter = Object.freeze({
  [CreditScoreType.creditScoreA]: 'A',
  [CreditScoreType.creditScoreB]: 'B',
  [CreditScoreType.creditScoreC]: 'C',
  [CreditScoreType.creditScoreD]: 'D',
  [CreditScoreType.creditScoreE]: 'E',
  [CreditScoreType.creditScoreF]: 'F',
  [CreditScoreType.creditScoreG]: 'G',
  [CreditScoreType.creditScoreH]: 'H',
});

export const CreditScoreTypeChartLetter = Object.freeze({
  [CreditScoreChartGrade[CreditScoreType.creditScoreA]]: 'A',
  [CreditScoreChartGrade[CreditScoreType.creditScoreB]]: 'B',
  [CreditScoreChartGrade[CreditScoreType.creditScoreC]]: 'C',
  [CreditScoreChartGrade[CreditScoreType.creditScoreD]]: 'D',
  [CreditScoreChartGrade[CreditScoreType.creditScoreE]]: 'E',
  [CreditScoreChartGrade[CreditScoreType.creditScoreF]]: 'F',
  [CreditScoreChartGrade[CreditScoreType.creditScoreG]]: 'G',
  [CreditScoreChartGrade[CreditScoreType.creditScoreH]]: 'H',
});

export const CreditScoreChartColor = Object.freeze({
  [CreditScoreChartGrade[CreditScoreType.creditScoreA]]: '#008629',
  [CreditScoreChartGrade[CreditScoreType.creditScoreB]]: '#26A544',
  [CreditScoreChartGrade[CreditScoreType.creditScoreC]]: '#4DB74F',
  [CreditScoreChartGrade[CreditScoreType.creditScoreD]]: '#F4A651',
  [CreditScoreChartGrade[CreditScoreType.creditScoreE]]: '#E8860E',
  [CreditScoreChartGrade[CreditScoreType.creditScoreF]]: '#C52A36',
  [CreditScoreChartGrade[CreditScoreType.creditScoreG]]: '#C52A36',
  [CreditScoreChartGrade[CreditScoreType.creditScoreH]]: '#C52A36',
});

export const CreditScoreTypeName = Object.freeze({
  [CreditScoreType.creditScoreA]: 'Excellent',
  [CreditScoreType.creditScoreB]: 'Good',
  [CreditScoreType.creditScoreC]: 'Okay',
  [CreditScoreType.creditScoreD]: 'Fair',
  [CreditScoreType.creditScoreE]: 'Poor',
});

export const CreditScoreTypeStatus = Object.freeze({
  [CreditScoreType.creditScoreA]: CreditScoreStatusType.normal,
  [CreditScoreType.creditScoreB]: CreditScoreStatusType.normal,
  [CreditScoreType.creditScoreC]: CreditScoreStatusType.normal,
  [CreditScoreType.creditScoreD]: CreditScoreStatusType.warning,
  [CreditScoreType.creditScoreE]: CreditScoreStatusType.warning,
  [CreditScoreType.creditScoreF]: CreditScoreStatusType.risk,
  [CreditScoreType.creditScoreG]: CreditScoreStatusType.risk,
  [CreditScoreType.creditScoreH]: CreditScoreStatusType.risk,
});

export function toOptions() {
  return Object.entries(CreditScoreTypeLetter).map(([value, label]) => ({ label, value }));
}

export const getCreditScoreGradeColorClassName = memoize((score) => {
  switch (true) {
    case CreditScoreTypeStatus[score] === CreditScoreStatusType.normal:
      return 'u-color-primary';

    case CreditScoreTypeStatus[score] === CreditScoreStatusType.risk:
      return 'u-color-danger';

    default:
      return 'u-color-warn';
  }
});

export const getCreditScoreGradeColor = memoize((score) => {
  switch (true) {
    case CreditScoreTypeStatus[score] === CreditScoreStatusType.normal:
      return 'teal';

    case CreditScoreTypeStatus[score] === CreditScoreStatusType.risk:
      return 'danger';

    default:
      return 'warning';
  }
});
